import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/api/auth/auth.service';
import { catchError, of, map } from 'rxjs';

export const guestGuard: CanActivateFn = (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.user()) {
        console.log('User is authenticated, redirecting to home');
        router.navigate(['/home']);
        return false;
    }

    return auth.getCurrentUser().pipe(
        map((response) => {
            if (response.data) {
                // User is authenticated, redirect to home
                auth.setUser(response.data);
                console.log('User is authenticated, redirecting to home');
                router.navigate(['/home']);
                return false;
            }
            // No valid user, allow access to guest route
            console.log('User is not authenticated, allowing access to guest route');
            return true;
        }),
        catchError(() => {
            // Error means no valid session, allow guest access
            console.log('User is not authenticated, allowing access to guest route');
            return of(true);
        })
    );
};
